import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'arrow-back-up', 'ArrowBackUp', [["path",{"d":"M9 14l-4 -4l4 -4"}],["path",{"d":"M5 10h11a4 4 0 1 1 0 8h-1"}]]);